import { Module } from "@/services/module";

class ConfigTimeParams extends Module {
  constructor() {
    super(false);
  }
}

export default new ConfigTimeParams();
